<div class="d-flex justify-content-between align-items-end pb-3 px-3 autocomlete-header">
  <h1 mat-dialog-title class="text-black fw-medium p-0 mb-0">
    @if (!data.isUpdatingGroup) {
      <span>{{ 'groupManagement.button.createGroup' | translate }}</span>
    }
    @if (data.isUpdatingGroup) {
      <span>{{ 'groupManagement.button.updateGroup' | translate }}</span>
    }
  </h1>

  <button class="border-0 bg-transparent delete-btn" (click)="onClose()">
    <i class="das das-corss fs-12 close-btn"></i>
  </button>
</div>
<!-- Dialog Content -->
<mat-dialog-content class="dialog-content">
  <div class="px-3">
    <!-- Group Name Input -->
    <div class="field-wrapper full-width">
      <mat-form-field appearance="outline" class="full-width">
        <input
          matInput
          placeholder="{{ 'groupManagement.labels.enterGroupName' | translate }}"
          class="fs-14"
          [(ngModel)]="groupName"
          (keydown.enter)="onSubmit()"
          (keydown)="$event.stopPropagation()"
        />
      </mat-form-field>
    </div>

    <!-- Users Selected Count -->
    <div class="users-selected pt-3">
      <span class="users-text fs-16 text-muted">{{ 'groupManagement.labels.usersSelected' | translate }}: </span>
      <span class="users-count fs-16 text-dark fw-medium">{{ data.selectedCount }}</span>
    </div>
    <hr />
    <!-- Warning Message -->
    <span class="d-flex align-items-center gap-3 ext-info">
      <i class="das das-info-icon text-dark fs-5 m-0 p-0"></i>
      <p class="text-muted fs-16 mb-0 pt-1 lh-sm">
        {{ 'groupManagement.groupInformation' | translate }}
      </p>
    </span>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="px-3 pt-3 pb-3 d-flex gap-3" align="end">
  <button
    class="btn rounded-1 fs-14 btn-primary px-5 fw-bold white-space-nowrap"
    (click)="onSubmit()"
    [disabled]="!groupName.trim() || isSubmitting"
  >
    @if (!isSubmitting && !data.isUpdatingGroup) {
      <span>{{ 'groupManagement.button.create' | translate }}</span>
    }
    @if (!isSubmitting && data.isUpdatingGroup) {
      <span>{{ 'groupManagement.button.update' | translate }}</span>
    }
  </button>
  <button class="btn btn-outline-primary fw-bold px-5 fs-14 rounded-1" (click)="onCancel()">
    {{ 'actions.cancel' | translate }}
  </button>
</mat-dialog-actions>
